import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { AccessTime, AccountBalanceWallet, Check, Close, CreditCard, } from '@mui/icons-material';
import popup from '../DashboardPopup/DashboardPopup.module.css';
import styles from './DashboardHistory.module.css';
;
export default function DashboardHistory({ transactions, close }) {
    const { t } = useTranslation();
    const SUCCESS = {
        icon: _jsx(Check, {}),
        color: 'success',
    };
    const PAY = {
        icon: _jsx(CreditCard, {}),
        color: 'wait',
    };
    const FAIL = {
        icon: _jsx(Close, {}),
        color: 'error',
    };
    const REFUND = {
        icon: _jsx(AccountBalanceWallet, {}),
        color: 'success',
    };
    const WAITING = {
        icon: _jsx(AccessTime, {}),
        color: 'wait',
    };
    const TRANSACTIONS_STYLE = {
        succeeded: SUCCESS,
        created: SUCCESS,
        chargeable: PAY,
        disputed: WAITING,
        failed: FAIL,
        canceled: FAIL,
        off: FAIL,
        pending: WAITING,
        partially_refunded: REFUND,
        refunded: REFUND,
    };
    const getClassIcon = (transaction) => `${styles.iconContainer} ${styles[TRANSACTIONS_STYLE[transaction.status].color]}`;
    const getClassStatus = () => `${styles.subtle} ${styles.left}`;
    return (_jsx("div", { className: popup.background, children: _jsxs("section", { className: `${popup.popup} ${styles.popup}`, children: [_jsxs("div", { className: styles.header, children: [_jsxs("div", { children: [_jsx("p", { className: styles.title, children: t('history.title') }), _jsx("p", { className: styles.description, children: t('history.description') })] }), _jsx("button", { type: "button", "aria-label": "Close", onClick: close, className: styles.close, children: _jsx(Close, { className: styles.icon }) })] }), _jsx("div", { className: styles.main, children: transactions === null || transactions === void 0 ? void 0 : transactions.map((transaction) => {
                        var _a;
                        return (_jsxs("div", { className: styles.transaction, children: [_jsxs("div", { className: styles.row, children: [_jsx("div", { className: getClassIcon(transaction), children: (_a = TRANSACTIONS_STYLE[transaction.status]) === null || _a === void 0 ? void 0 : _a.icon }), _jsxs("div", { children: [_jsx("p", { className: styles.society, children: transaction.society }), _jsx("p", { className: styles.subtle, children: transaction.updated })] })] }), _jsxs("div", { children: [_jsxs("p", { className: styles.amount, children: [transaction.amount.toLocaleString(), "\u20AC"] }), _jsx("p", { className: getClassStatus(), children: transaction.status.toLocaleString() })] })] }, transaction.id));
                    }) })] }) }));
}
